/* eslint-disable @typescript-eslint/no-explicit-any */
import api from '@/services/api';
import { NewNicheRequest, UploadRequest } from '@/types';

export async function serviceUpload(data: UploadRequest) {
  try {
    const formData = new FormData();
    formData.append('pixelId', data.pixelId);
    formData.append('token', data.token);
    formData.append('userName', data.userName);
    formData.append('email', data.email);
    formData.append('eventType', data.typeNiche.name);

    if (data.file) {
      formData.append('file', data.file);
    }

    const response = await api.post<{ success: boolean; message: string }>('/upload', formData);

    return response.data;
  } catch (error: any) {
    const messageError = error?.response?.data?.message || error?.message;
    if (messageError) {
      throw new Error(messageError);
    }
    throw new Error('Erro interno do servidor');
  }
}

export async function serviceUploadNewNiche(data: NewNicheRequest) {
  try {
    const formData = new FormData();
    formData.append('name', data.name);

    if (data.file) {
      formData.append('file', data.file);
    }

    const response = await api.post<{ success: boolean; message: string }>(
      '/database-niches',
      formData,
    );

    return response.data;
  } catch (error: any) {
    const messageError = error?.response?.data?.message || error?.message;
    if (messageError) {
      throw new Error(messageError);
    }
    throw new Error('Erro interno do servidor');
  }
}
